import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import logoDark from "@/assets/brand/logo-full-dark.png";

export default function NotFound() {
  return (
    <div data-testid="notfound-page" className="min-h-[80vh] grid place-items-center px-6 py-24">
      <div className="max-w-xl text-center">
        <img
          src={logoDark}
          alt="Dreamy Interiors"
          className="h-20 w-auto mx-auto opacity-90 select-none"
          draggable="false"
        />
        <p className="overline text-[#A07F2D] mt-10">404</p>
        <h1 className="font-heading text-5xl sm:text-6xl font-light tracking-tight mt-4 leading-[1.05]">
          This page has slipped <em className="italic">between the walls.</em>
        </h1>
        <p className="text-sm text-[#5C5752] mt-6">
          The address you tried doesn't exist on Dreamy Interiors. It may have moved, been renamed, or never existed at all.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-btn"
          className="mt-10 inline-flex items-center gap-3 bg-[#1C1A17] text-white hover:bg-[#2D2925] px-7 py-4 uppercase tracking-widest text-xs transition-colors"
        >
          Back to home <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
}
